<template>
  <m-dialog ref="dlg" :isclose="true" @save="save" :fullscreen="true" :title="model && model.id ? 'Ubah Berkas' : 'Tambah Berkas'">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" sm="12" md="10" lg="8">
          <!-- Konten Kolom 1 -->
          <v-card>
            <v-card-title>Formulir Tambah Berkas</v-card-title>
            <v-card-text>
              <v-form @submit.prevent data-vv-scope="form" lazy-validation>
                <v-row dense>
                  <v-col cols="12" md="12">
                    <!-- Nama Berkas -->
                    <label for="nama-berkas" class="black--text">Nama Berkas</label>
                    <v-text-field
                      placeholder="Masukkan Nama Berkas"
                      outlined
                      dense
                      v-model="model.nama_berkas"
                      id="nama-berkas"
                      data-vv-name="nama_berkas"
                      data-vv-as="Nama Berkas"
                      v-validate="'required'"
                      :error-messages="errors.collect('form.nama_berkas')"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12">
                    <!-- Jenis Berkas -->
                    <label for="jenis-berkas" class="black--text">Pilih Jenis Berkas</label>
                    <v-select
                      dense
                      placeholder="Pilih Jenis Berkas"
                      outlined
                      v-model="model.jenis_berkas"
                      :items="jenisBerkases"
                      @change="changeSasaran(model.jenis_berkas)"
                      item-text="keterangan"
                      item-value="id"
                      return-object
                      id="jenis-berkas"
                      data-vv-name="jenis_berkas"
                      data-vv-as="Jenis Berkas"
                      v-validate="'required'"
                      :error-messages="errors.collect('form.jenis_berkas')"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="12">
                    <!-- Unggah Berkas -->
                    <label for="unggah-berkas" class="black--text">Unggah Berkas</label>
                    <v-file-input
                      dense
                      outlined
                      v-model="model.file"
                      prepend-icon=""
                      accept=".jpg, .jpeg"
                      append-icon="mdi-file"
                      id="unggah-berkas"
                      persistent-hint
                      placeholder="Berkas dengan tipe .jpg, .png, .pdf (Maks: 1 MB)"
                      data-vv-name="file_berkas"
                      data-vv-as="File Berkas"
                      v-validate="model && model.id ? '' : 'required'"
                      :error-messages="errors.collect('form.file_berkas')"
                      :hint="model && model.id ? 'Jika file tidak berubah maka tidak perlu melakukan unggah ulang file' : ''"
                    ></v-file-input>
                  </v-col>

                  <v-col cols="12" md="12">
                    <!-- Pilih Sasaran -->
                    <label for="pilih-sasaran" class="black--text">Pilih Sasaran</label>
                    <v-select
                      multiple
                      dense
                      outlined
                      v-model="model.sasaran"
                      placeholder="Pilih Sasaran Seri"
                      :items="itemSasarans"
                      item-text="nama"
                      item-value="id"
                      return-object
                      id="pilih-sasaran"
                      data-vv-name="sasaran"
                      data-vv-as="Sasaran"
                      v-validate="'required'"
                      :error-messages="errors.collect('form.sasaran')"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      jenisBerkases: [],
      itemSasarans: [],
      berkas: null,
      model: {
        nama_berkas: null,
        jenis_berkas: null,
        file: null,
        sasaran: []
      }
    };
  },
  methods: {
    open(val, obj, item) {
      this.jenisBerkases = [...val];
      this.berkas = obj;
      //jika isEdit
      if (item) {
        this.model = { ...item };

        let sasaranTmp = this.model.sasaran.map(item => ({
          id: item.instansi.id,
          nama: item.instansi.nama
        }));

        this.model.sasaran = [...sasaranTmp];

        this.changeSasaran(val);
      } else {
        this.model = {
          nama: null,
          jenis_berkas: null,
          file: null,
          sasaran: []
        };
      }

      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },

    changeSasaran(val) {
      if (this.model.id) {
        let jenisBerkasFiltered = this.jenisBerkases.filter(item => item.id == this.model.jenis_berkas.id);

        this.itemSasarans = [
          ...jenisBerkasFiltered[0].sasaran.map(item => ({
            id: item.id,
            nama: item.nama
          }))
        ];
      } else {
        this.itemSasarans = [...val.sasaran];
      }
    },

    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store.dispatch("user/berkas", this.model).then(res => {
            this.$info("Unggah Berkas Berhasil");
            this.$refs.dlg.resolve();
            return res;
          });
        })
        .catch(e => e);
    }
  }
};
</script>
